// Need to use the React-specific entry point to import createApi
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { Config } from "../config";
import { BioPDF, Biography, BiographySection, BiographySummary } from "./types/bioApiTypes";

const apiManagementRootUrl: string | undefined = Config.REACT_APP_CCL_API_MANAGEMENT_URL;

// Define a service using a base URL and expected endpoints
export const cclTokenedEnterpriseCoachingBiographyApi = createApi({
    reducerPath: "cclTokenedEnterpriseCoachingBiographyApi",
    tagTypes: ["biography"],

    baseQuery: fetchBaseQuery({
        baseUrl: apiManagementRootUrl,
        prepareHeaders: (headers, { getState }) => {
            //we should probably change this.
            const token = localStorage.getItem("token") as string;
            headers.set("authorization", `Bearer ${token}`);
            return headers;
        },
    }),
    endpoints: (builder) => ({
        getBiography: builder.query<Biography, string>({
            query: (pKey) => `enterprise-coaching/v1/Biography/biography/${pKey}`,
            providesTags: ["biography"],
        }),
        getBiographies: builder.query<BiographySummary[], string>({
            query: (pKey) => `enterprise-coaching/v1/Biography/biographies/${pKey}`,
            providesTags: ["biography"],
        }),
        saveBiographySection: builder.mutation<boolean, BiographySection>({
            query: (args) => ({
                url: `enterprise-coaching/v1/Biography/biography/update-section/${args.pKey}/${args.bioId}`,
                method: "POST",
                body: args,
            }),
            invalidatesTags: ["biography"],
        }),
        saveBiographyTitle: builder.mutation<boolean, Biography>({
            query: (args) => ({
                url: `enterprise-coaching/v1/Biography/biography/update-title/${args.pKey}`,
                method: "POST",
                body: args,
            }),
            invalidatesTags: ["biography"],
        }),
        downloadPDF: builder.mutation<any, BioPDF>({
            queryFn: async (bioPDF, api, extraOptions, baseQuery) => {
                const result = await baseQuery({
                    url: `enterprise-coaching/v1/Biography/biography/pdf/${bioPDF.pKey}/${bioPDF.id}`,
                    method: "GET",
                    responseHandler: (response) => response.blob(),
                });
                var blobresult = result?.data != null ? (result.data as Blob) : null;
                if (blobresult == null) return { data: null };

                var hiddenElement = document.createElement("a");
                var url = window.URL || window.webkitURL;
                var blobfile = url.createObjectURL(blobresult);
                hiddenElement.href = blobfile;
                hiddenElement.target = "_blank";
                hiddenElement.download = bioPDF.pdfName ? bioPDF.pdfName : "biography_download";
                hiddenElement.click();
                return { data: null };
            },
        }),
    }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
    useGetBiographyQuery,
    useGetBiographiesQuery,
    useSaveBiographySectionMutation,
    useSaveBiographyTitleMutation,
    useDownloadPDFMutation,
} = cclTokenedEnterpriseCoachingBiographyApi;
